import HttpRequest from '@/request'
const API = {
  REGION: '/front/energygov/v1/supervisionDicRegion/list',//区域列表
  DISTRICTS_AREA: '/front/energygov/v1/supervisionDicRegion/list',
  INDUSTRY: '/front/energygov/v1/supervisionDicIndustry/list', //'/front/supervision/v1/supervisionDicIndustry/list',//行业列表
  SUPERVISION_LIST:'/front/energygov/v1/supervisionDocumentRecord/list',
  GET_DOCUMENT_LIST_BT_UNIT_ID:'/front/energygov/v1/supervisionDocumentTemplate/list',
  GET_DOC_CONTENT_BY_ID:'/front/energygov/v1/supervisionDocumentTemplate',
  ADD_DOCUMENT_WRITEN_RECORD:'/front/energygov/v1/supervisionDocumentRecord/insert',
  GET_WRITEN_SUPER_INFO:'/front/energygov/v1/supervisionDocumentRecord/detail',
  CHANGE_DOC_STATUTS:'/front/energygov/v1/supervisionDocumentRecord/updateStatus',
  GET_DOC_CONTENT_BY_ID_FOR_RECORD:'/front/energygov/v1/supervisionDocumentInfo/info',
  UPDATE_DOCUMENT_WRITEN_RECORD:'/front/energygov/v1/supervisionDocumentRecord/update',
  DOWN_LOAD_ERITEN:'/front/energygov/v1/supervisionDocumentRecord/downloadFile',
  SUPERVISION_LIST_OF_SENCE:'/front/energygov/v1/supervisionEnforcement/'

}
export function getDistricts (parameter:any) {
    return HttpRequest({
      url: API.DISTRICTS_AREA + '/' + parameter,
      method: 'get',
    })
  }


  

/**
 * 获取行业列表选项
 */
 export function getIndustryListRequest() {
  return HttpRequest({
    url: API.INDUSTRY,
    method: 'get'
  })
}

/**
 * 新增书面监察含保存下发
 */
 export function doAddSuperivision(parameter:any) {
  return HttpRequest({
    url: API.ADD_DOCUMENT_WRITEN_RECORD,
    method: 'post',
    data:parameter
  })
}

/**
 * 新增现场监察含保存下发
 */
 export function doAddSuperivisionEnforcement(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcement/insert',
    method: 'post',
    data:parameter
  })
}


/**
 * 书面监察文件打包下载
 */
 export function dowLoadWritenFile(parameter:any) {
  return HttpRequest({
    url: API.DOWN_LOAD_ERITEN +'/' + parameter,
    method: 'post',
    responseType:'blob',
  })
}

/**
 * 现场监察文件打包下载
 */
 export function dowLoadSenceFile(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcementNotification/downloadFile' +'/' + parameter,
    method: 'get',
    responseType:'blob',
  })
}


/**
 * 编辑书面监察含保存下发
 */
 export function updateSuperivision(parameter:any) {
  return HttpRequest({
    url: API.UPDATE_DOCUMENT_WRITEN_RECORD+'/'+parameter.id,
    method: 'put',
    data:parameter
  })
}
/**
 * 编辑现场监察含保存下发
 */
 export function updateEnforcement(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcement/update/'+parameter.id,
    method: 'post',
    data:parameter
  })
}



/**
 * 书面监察改变文书状态
 */
 export function changeDocStatus(parameter:any) {
  return HttpRequest({
    url: API.CHANGE_DOC_STATUTS+'/'+parameter.recordId,
    method: 'put',
    data:parameter
  })
}




/**
 * 根据文书id获取书面监察记录详情
 */
 export function getWritenSuperivisionInfo(parameter:any) {
  return HttpRequest({
    url: API.GET_WRITEN_SUPER_INFO+'/'+parameter,
    method: 'get'
  })
}


/**
 * 根据文书id获取现场监察记录详情
 */
 export function getsupervisionEnforcementInfo(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcement'+'/'+parameter,
    method: 'get'
  })
}


/**
 * 根据文书id获取文书内容
 */
 export function GetDocInfoById(parameter:any) {
  return HttpRequest({
    url: API.GET_DOC_CONTENT_BY_ID+'/'+parameter,
    method: 'get'
  })
}

/**
 * 根据文书id获取文书内容当生成监察记录的时候调用
 */
 export function getDocInfoForEidt(parameter:any) {
  return HttpRequest({
    url: API.GET_DOC_CONTENT_BY_ID_FOR_RECORD+'/'+parameter,
    method: 'get'
  })
}


/**
 * 根据监察单位id获取文书模板列表
 */
 export function getDocumentListRequest(parameter:any) {
  return HttpRequest({
    url: API.GET_DOCUMENT_LIST_BT_UNIT_ID,
    method: 'get'
  })
}

/**
 * 获取书面监察列表数据
 */
 export function getSupervisionDocumentRecordList(params:any) {
  return HttpRequest({
    url: API.SUPERVISION_LIST,
    method: 'get',
    params
  })
}

/**
 * 获取书面监察列表数据
 */
 export function getSceneSupervisionList(params:any) {
  return HttpRequest({
    url: API.SUPERVISION_LIST_OF_SENCE,
    method: 'get',
    params
  })
}


export function doFinishSuperivion(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcement/finish',
    method: 'post',
    data:parameter
  })
}

export function saveSupervisionRequest(parameter:any) {
  return HttpRequest({
    url: '/front/energygov/v1/supervisionEnforcement/uploadEvidence',
    method: 'post',
    data:parameter
  })
}
